import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon, SearchIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const NotFound = () => {
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-4338">
      <div className="max-w-md w-full text-center" data-id="element-4339">
        <div className="mb-8" data-id="element-4340">
          <div className="w-24 h-24 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-4341">
            <span className="text-4xl font-bold text-white" data-id="element-4342">404</span>
          </div>
          <h1 className="text-3xl font-bold text-blue-900 mb-2" data-id="element-4343">
            Page Not Found
          </h1>
          <p className="text-gray-600" data-id="element-4344">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-4345">
          <h2 className="text-lg font-bold text-blue-900 mb-4" data-id="element-4346">
            Here are some helpful links:
          </h2>
          <div className="space-y-3" data-id="element-4347">
            <Link to="/" className="flex items-center justify-center p-3 bg-blue-50 rounded-md text-blue-900 hover:bg-blue-100 transition-colors" data-id="element-4348">
              <HomeIcon className="h-5 w-5 mr-2" data-id="element-4349" />
              Return to Homepage
            </Link>
            <Link to="/contact" className="flex items-center justify-center p-3 bg-blue-50 rounded-md text-blue-900 hover:bg-blue-100 transition-colors" data-id="element-4350">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4351">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-4352" />
              </svg>
              Contact Us
            </Link>
            <button onClick={() => window.history.back()} className="flex items-center justify-center p-3 bg-blue-50 rounded-md text-blue-900 hover:bg-blue-100 transition-colors w-full" data-id="element-4353">
              <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-4354" />
              Go Back
            </button>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4355">
          <h2 className="text-lg font-bold text-blue-900 mb-4" data-id="element-4356">
            Search our website
          </h2>
          <div className="relative" data-id="element-4357">
            <input type="text" placeholder="Search..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-4358" />
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-4359" />
          </div>
        </div>
        <div className="mt-8" data-id="element-4360">
          <p className="text-gray-600 text-sm" data-id="element-4361">
            If you believe this is an error, please{' '}
            <Link to="/contact" className="text-blue-700 hover:underline" data-id="element-4362">
              contact us
            </Link>{' '}
            and let us know.
          </p>
        </div>
      </div>
    </div>;
};
export default NotFound;